import React from 'react';
import Card from '../common/Card.redesign';
import Project from 'src/models/Project';
// import { ContextMenuAction } from '../common/ContextMenu';
import Button from '../controls/forms/redesign/FormButton';

interface IProjectCardProps {
    project: Project;
    key?: string;
    onEditProjectClick: () => void;
    onAdministerProjectClick: () => void;
    editProject?: (id: number) => void;
}

const ProjectCard = (props: IProjectCardProps) => {
    // const menuActions: ContextMenuAction[] = [{ text: 'Edit', action: () => props.editProject(props.project.projectNumber) }];

    const rightBadgePanel = () => {
        if (props.project.updateNeeded === true) {
            return (
                <div style={{ display: 'flex', columnGap: '3rem', alignItems: 'center' }}>
                    <div>{props.project.state?.name}</div>
                    <div style={{ padding: '.4rem', background: 'yellow', fontWeight: 'bold', fontSize: '.8em' }}>Setup Required</div>
                </div>
            );
        }

        return props.project.state?.name || '[State Missing]';
    };

    const infoBarPanel = () => {
        const infoBar = (
            <div>
                <span className="title">{props.project.name}</span> - {countyNames}
            </div>
        );

        // if (props.project.updateNeeded === true) {
        //     return <div />;
        // }

        return infoBar;
    };

    const countyNames = props.project.counties
        .map((x) => {
            return x.name;
        })
        .toString()
        .replace(/,/g, ', ');
    return (
        <Card
            badge={`${props.project.projectNumber}`}
            // contextActions={menuActions}
            // newContext={true}
            rightBadgePanel={rightBadgePanel()}
            infoBar={infoBarPanel()}
            style={{ marginTop: '1rem' }}
        >
            {!!props.project && !!props?.project?.updateNeeded === true ? (
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginLeft: '21rem' }}>
                    <div style={{ padding: '.5rem' }}>
                        <Button text="Finish Project Setup" intent="primary" onClick={props.onAdministerProjectClick} />
                    </div>
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'space-around', padding: '1.5rem', marginBottom: '1rem' }}>
                    <div style={{ padding: '.5rem', height: '2rem' }}>
                        <Button text="Edit Project" intent="primary" onClick={props.onEditProjectClick} />
                    </div>
                    {/* <div style={{ padding: '.5rem' }}>
                        <Button text="Administer Project" intent="primary" onClick={props.onAdministerProjectClick} />
                    </div> */}
                </div>
            )}
        </Card>
    );
};

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/cards/ProjectCard.tsx